import React from "react";
import robotImg from "../assets/robot.png";
import "./OptionSelector.css";

export default function OptionSelector({ onSelect, themeMode }) {
  return (
    <div className="option-container">
      
      <h2
        className="title"
        style={{
          color: themeMode === "dark" ? "white" : "black",
          transition: "color 0.3s ease"
        }}
      >
        Hi! I'm FinSight, your financial AI assistant.  
        What do you want to learn today?
      </h2>

      <div className="content">
        <img src={robotImg} alt="Robot" className="robot" />

        <div className="options">
          <div className="bubble" onClick={() => onSelect("concepts")}>
            Financial Concepts
          </div>

          <div className="bubble" onClick={() => onSelect("companies")}>
            Company Statement
          </div>

          <div className="bubble" onClick={() => onSelect("budget")}>
            Financial Budget
          </div>
        </div>
      </div>
    </div>
  );
}
